import {
  customerMarketShopfrontJobsApi,
  marketApi
} from '@envato/foundation-types'

import {
  ActionTypes as NewestItemsActionTypes,
  TypeKeys as NewestItemsTypeKeys
} from '../actions/home/fetchNewestItemsByCategory'
import {
  ActionTypes as HomeActionTypes,
  TypeKeys as HomeTypeKeys
} from '../actions/homePage'

import { ISeoMetadata } from '../../typings/seoMetadata'
import { IPageBlock } from '../../typings/pageBlocks'

import { updateNewestItemsBlock } from '../utils/homePage'

interface ISearchResultsByCategory {
  [propName: string]: customerMarketShopfrontJobsApi.IBaseResult | undefined
}

export interface IState {
  readonly newestItems: ISearchResultsByCategory
  readonly featuredItems?: customerMarketShopfrontJobsApi.IBaseResult
  readonly freeItems?: customerMarketShopfrontJobsApi.IBaseResult
  readonly featuredAuthor?: customerMarketShopfrontJobsApi.IFeaturedAuthorWithItemsResult
  readonly metadata?: ISeoMetadata
  readonly newestItemsCategory: string
  readonly newestItemsPendingCategory?: string
  readonly categories?: marketApi.CategoriesResult
  readonly blocks: IPageBlock[]
  readonly blocksB: IPageBlock[]
  readonly blocksC: IPageBlock[]
  readonly blocksD: IPageBlock[]
}

const initialState: IState = {
  newestItems: { all: undefined },
  newestItemsCategory: 'all',
  featuredItems: undefined,
  categories: undefined,
  blocks: [],
  blocksB: [],
  blocksC: [],
  blocksD: []
}

export const reducer = (
  state = initialState,
  action: HomeActionTypes | NewestItemsActionTypes
): IState => {
  switch (action.type) {
    case HomeTypeKeys.GET_HOME_PAGE_API_SUCCESS:
      const newestItemsCategory = 'all'
      const newestItems = action.payload.newest_items
        ? {
            [newestItemsCategory]: action.payload.newest_items
          }
        : { all: undefined }

      const {
        featured_items: featuredItems,
        free_items: freeItems,
        featured_author: featuredAuthor,
        categories,
        blocks,
        blocksB,
        blocksC,
        blocksD
      } = action.payload

      return {
        metadata: action.payload.metadata,
        newestItems,
        newestItemsCategory,
        featuredItems,
        freeItems,
        featuredAuthor,
        categories,
        blocks,
        blocksB,
        blocksC,
        blocksD
      }
    case NewestItemsTypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING:
      return { ...state, newestItemsPendingCategory: action.payload.category }
    case NewestItemsTypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        ...updateNewestItemsBlock(state, action.payload.searchResults),
        newestItems: {
          ...state.newestItems,
          [action.payload.category]: action.payload.searchResults
        },
        newestItemsCategory: action.payload.category,
        newestItemsPendingCategory: undefined
      }
    case NewestItemsTypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL:
      return {
        ...state,
        newestItemsPendingCategory: undefined
      }

    default:
      return state
  }
}
